module.exports = __webpack_public_path__ + "media/images/about-logo-asa-e7d0a517808f352f6bc32f8109c0c7bd.png";